<!-- Header section (showContent= true means the user is coming from APP, false coming from web)-->
@if (!showContent) {
  <login-header></login-header>
}
<!-- THis header is only for APP users Header -->
@if (showContent) {
  <header class="fc_header gray_bg sticky-top">
    <nav class="navbar navbar-expand-md  bg-dark navbar-light">
      <div class="container-fluid flex-md-wrap flex-lg-nowrap">
        <a class="navbar-brand">
          <img class="fc_logo" src="/assets/images/familycentral-logo.svg" width="140" height="70" alt="Family central logo">
        </a>
      </div>
    </nav>
  </header>
}

<!-- Login hero -->
<div class="login_hero text-center">
  <div class="px-90 m-auto">
    <div class="login_options d-md-grid" [ngClass]="dynamicClass">
      @if (!showContent) {
        <div class="single_option for_families d-flex justify-content-center align-items-center">
          <div class="login_content">
            <div class="login_texttop mb-3">
              <img class="mb-3" src="/assets/images/families-icon.svg" width="50" height="50" alt="">
              <h2 class="lp_h2 text-capitalize">For Families</h2>
              <p class="text-capitalize">Prepare for your family’s day-to-day needs, important milestones, and inevitable emergencies all in one place.</p>
            </div>
            <button type="button" (click)="auth.login()" class="primary_btn mb-3">Log In</button>
            <p class="mb-0">New user? <a routerLink="/questionnaires" class="text_red text-decoration-underline">Sign up</a></p>
          </div>
        </div>
      }

      <div class="single_option for_professional d-flex justify-content-center align-items-center">
        <div class="login_content">
          <div class="login_texttop mb-3">
            <img class="mb-3" src="/assets/images/professional-icon.svg" width="46" height="46" alt="">
            <h2 class="lp_h2 text-capitalize">For Professionals</h2>
            <p class="text-capitalize">With our secure storage, you can give your clients peace of mind knowing all their critical documents are stored in one place</p>
          </div>
          <button type="button" (click)="ContinueProfiessional()" class="border_btn red_border mb-3">Log In</button>
          @if (!showContent) {
            <p class="mb-0">New user? <a routerLink="/professional/signup" class="text_white text-decoration-underline"><strong>Sign up</strong></a></p>
          }
        </div>
      </div>
    </div>
  </div>
</div>


<!-- Contact options -->
<div class="contact_section">
  <div class="px-90 m-auto">
    <div class="contact_content d-md-grid align-items-center">
      <div class="contact_details">
        <h2 class="lp_h2 mb-4 text-capitalize">Need some assistance? <br>We’re here to help!</h2>
        <p class="mb-0">Contact us Monday - Friday <br>8 a.m - 5 p.m EST</p>
      </div>
      <div class="contact_options">
        <ul class="contact_btns d-flex flex-wrap">
          <li>
            <a class="btn border rounded-3 p-3" href="tel:+1888-780-3264">
              <img class="mb-3" src="/assets/images/call-circle.svg" width="40" height="40" alt="" loading="lazy">
              <strong class="d-block">Call or Text</strong>
              <span>1-888-780-3264</span>
            </a>
          </li>
          <li>
            <a class="btn border rounded-3 p-3" href="mailto:hello&#64;familycentral.com">
              <img class="mb-3" src="/assets/images/email-circle.svg" width="40" height="40" alt="" loading="lazy">
              <strong class="d-block">Email</strong>
              <span>hello&#64;familycentral.com</span>
            </a>
          </li>
          <li>
            <a class="btn border rounded-3 p-3" routerLink="/book-an-appointment">
              <img class="mb-3" src="/assets/images/book-appointment-icon.svg" width="40" height="40" alt="" loading="lazy">
              <strong class="d-block">Appointment</strong>
              <span>Book an appointment</span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>

<ng-template #professionpopup>
  <div class="modal-content signup-modal modal-lg">
    <div class="logo-class">
      <img class="logo" src="assets/images/familycentral-logo.svg" alt="Family Central logo" />
    </div>
    <button aria-label="close button" type="button" class="btn btn-close" data-bs-dismiss="modal"
    (click)="onClose()"></button>
    <h2 class="Welcome-text heading2 text-center">
      Welcome to Family Central for Professionals
    </h2>
    <p class="live-text text-center">
      We are completing the Trusted Professional Log In. This will be live
      before September 30th, 2023.
    </p>
  </div>
</ng-template>

<!-- Footer section -->
@if (!showContent) {
  <app-footer></app-footer>
}
